import { render } from "./tujuan.vue?vue&type=template&id=402fa843"
import script from "./tujuan.vue?vue&type=script&lang=js"
export * from "./tujuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__